"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildType = void 0;
var BuildType;
(function (BuildType) {
    BuildType["PROD"] = "prod";
    BuildType["DOGFOOD"] = "dogfood";
    BuildType["CANARY"] = "canary";
    BuildType["DEV"] = "dev";
    BuildType["UNSAFE"] = "unsafe";
})(BuildType = exports.BuildType || (exports.BuildType = {}));
//# sourceMappingURL=BuildTypes.js.map